import React from 'react'
import styles from './NotificationBadge.module.scss'
import Props from './types'
import classnames from 'classnames'

const NotificationBadge: React.FC<Props> = props => {

  const { notifications = 0 } = props

  const notificationBadgeClasses = classnames(
    styles['notification-badge'], {
      [styles['--hidden']]: notifications === 0,
      [styles['--selected']]: props.isActive
    }
  )

  return <div
    data-bdd="navigation-badge"
    className={notificationBadgeClasses}
  >
    {notifications}
  </div>

}

export default NotificationBadge
